(function () {
  /* Scroll distance over which the bar eases from clear → solid white */
  var FADE_START = 64;
  var FADE_DISTANCE = 320;
  var TEXT_FLIP_AT = 0.6;
  var MEGA_CLOSE_DELAY = 140;

  function syncOverlay(root) {
    var height = root.offsetHeight + 'px';
    var section = root.closest('.shopify-section') || root.parentElement;
    var overMedia = root.classList.contains('wpm-header--over-media');

    document.documentElement.style.setProperty('--wpm-header-height', height);
    if (section) section.style.setProperty('--wpm-header-height', height);

    document.documentElement.classList.toggle('wpm-header-overlay', overMedia);
  }

  function initHeader(root) {
    if (!root || root.dataset.wpmHeaderReady === 'true') return;
    root.dataset.wpmHeaderReady = 'true';

    var button = root.querySelector('[data-wpm-menu-toggle]');
    var nav = root.querySelector('[data-wpm-nav]');
    var fadeScroll = root.classList.contains('wpm-header--fade-scroll');
    var megaTrigger = root.querySelector('[data-wpm-mega-trigger]');
    var megaPanel = root.querySelector('[data-wpm-mega]');
    var searchRoots = root.querySelectorAll('[data-wpm-search]');
    var desktopMq = window.matchMedia('(min-width: 900px)');
    var megaCloseTimer = null;
    var ticking = false;

    function forceSolidHeader(on) {
      if (!fadeScroll) return;
      if (on) {
        root.style.setProperty('--wpm-header-scroll', '1');
        root.classList.add('is-scrolled');
      } else {
        updateScrollState();
      }
    }

    function setOpen(open) {
      if (!button || !nav) return;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.textContent = open ? button.dataset.labelClose : button.dataset.labelOpen;
      nav.classList.toggle('is-open', open);
      root.classList.toggle('is-menu-open', open);
      if (open) closeMega(true);
      forceSolidHeader(open);
    }

    function close() {
      setOpen(false);
    }

    function updateScrollState() {
      if (!fadeScroll) return;
      if (
        root.classList.contains('is-menu-open') ||
        root.classList.contains('is-mega-open') ||
        root.classList.contains('is-search-open')
      ) {
        root.style.setProperty('--wpm-header-scroll', '1');
        root.classList.add('is-scrolled');
        return;
      }
      var progress = (window.scrollY - FADE_START) / FADE_DISTANCE;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      root.style.setProperty('--wpm-header-scroll', progress.toFixed(3));
      root.classList.toggle('is-scrolled', progress >= TEXT_FLIP_AT);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateScrollState();
        ticking = false;
      });
    }

    function isDesktop() {
      return desktopMq.matches;
    }

    function openMega() {
      if (!megaTrigger || !megaPanel || !isDesktop()) return;
      clearTimeout(megaCloseTimer);
      megaPanel.hidden = false;
      megaTrigger.setAttribute('aria-expanded', 'true');
      root.classList.add('is-mega-open');
      forceSolidHeader(true);
    }

    function resetMegaVehicles() {
      if (!megaPanel) return;
      var vehicles = megaPanel.querySelector('[data-wpm-mega-vehicles]');
      if (!vehicles) return;
      var makes = vehicles.querySelector('[data-wpm-mega-makes]');
      var modelPanels = vehicles.querySelectorAll('[data-wpm-mega-models]');
      var makeButtons = vehicles.querySelectorAll('[data-wpm-mega-make]');
      if (makes) makes.hidden = false;
      modelPanels.forEach(function (panel) {
        panel.hidden = true;
      });
      makeButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function showMegaModels(index) {
      if (!megaPanel) return;
      var vehicles = megaPanel.querySelector('[data-wpm-mega-vehicles]');
      if (!vehicles) return;
      var makes = vehicles.querySelector('[data-wpm-mega-makes]');
      var target = vehicles.querySelector('[data-wpm-mega-models="' + index + '"]');
      if (!target) return;
      if (makes) makes.hidden = true;
      vehicles.querySelectorAll('[data-wpm-mega-models]').forEach(function (panel) {
        panel.hidden = panel !== target;
      });
      vehicles.querySelectorAll('[data-wpm-mega-make]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', btn.getAttribute('data-wpm-mega-make') === String(index) ? 'true' : 'false');
      });
      var back = target.querySelector('[data-wpm-mega-back]');
      if (back) {
        window.requestAnimationFrame(function () {
          back.focus();
        });
      }
    }

    function closeMega(immediate) {
      if (!megaTrigger || !megaPanel) return;
      clearTimeout(megaCloseTimer);
      var run = function () {
        megaPanel.hidden = true;
        megaTrigger.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-mega-open');
        resetMegaVehicles();
        if (!root.classList.contains('is-menu-open')) forceSolidHeader(false);
      };
      if (immediate) run();
      else megaCloseTimer = setTimeout(run, MEGA_CLOSE_DELAY);
    }

    function megaContains(node) {
      return (
        (megaTrigger && megaTrigger.contains(node)) ||
        (megaPanel && megaPanel.contains(node))
      );
    }

    if (button && nav) {
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        setOpen(!open);
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) {
          close();
          closeMega(true);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (megaTrigger && megaTrigger.getAttribute('aria-expanded') === 'true') {
          var openModels = megaPanel && megaPanel.querySelector('[data-wpm-mega-models]:not([hidden])');
          if (openModels) {
            resetMegaVehicles();
            var activeMake = megaPanel.querySelector('[data-wpm-mega-make][aria-expanded="true"]');
            var focusMake = activeMake || megaPanel.querySelector('[data-wpm-mega-make]');
            if (focusMake) focusMake.focus();
            return;
          }
          closeMega(true);
          megaTrigger.focus();
          return;
        }
        if (button.getAttribute('aria-expanded') === 'true') {
          close();
          button.focus();
        }
      });

      nav.querySelectorAll('a').forEach(function (link) {
        if (link.hasAttribute('data-wpm-mega-trigger')) return;
        link.addEventListener('click', close);
      });

      window.addEventListener(
        'resize',
        function () {
          if (desktopMq.matches) close();
          else closeMega(true);
          syncOverlay(root);
        },
        { passive: true }
      );
    } else {
      window.addEventListener(
        'resize',
        function () {
          syncOverlay(root);
        },
        { passive: true }
      );
    }

    if (megaTrigger && megaPanel) {
      megaTrigger.addEventListener('pointerenter', openMega);
      megaTrigger.addEventListener('focus', openMega);
      megaPanel.addEventListener('pointerenter', openMega);

      megaTrigger.addEventListener('pointerleave', function () {
        closeMega(false);
      });
      megaPanel.addEventListener('pointerleave', function () {
        closeMega(false);
      });

      root.addEventListener('focusout', function () {
        if (!isDesktop()) return;
        requestAnimationFrame(function () {
          if (!megaContains(document.activeElement)) closeMega(true);
        });
      });

      megaPanel.addEventListener('click', function (event) {
        var makeBtn = event.target.closest('[data-wpm-mega-make]');
        if (makeBtn && megaPanel.contains(makeBtn)) {
          event.preventDefault();
          showMegaModels(makeBtn.getAttribute('data-wpm-mega-make'));
          return;
        }
        var backBtn = event.target.closest('[data-wpm-mega-back]');
        if (backBtn && megaPanel.contains(backBtn)) {
          event.preventDefault();
          resetMegaVehicles();
          var firstMake = megaPanel.querySelector('[data-wpm-mega-make]');
          if (firstMake) firstMake.focus();
        }
      });

      /* Shop link keeps default navigation — do not preventDefault */
    }

    searchRoots.forEach(function (searchRoot) {
      var toggle = searchRoot.querySelector('[data-wpm-search-toggle]');
      var panel = searchRoot.querySelector('[data-wpm-search-panel]');
      var input = searchRoot.querySelector('.wpm-header-search__input');
      if (!toggle || !panel) return;

      function setSearchOpen(open) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        root.classList.toggle('is-search-open', open);
        if (open) {
          forceSolidHeader(true);
          if (input) {
            window.requestAnimationFrame(function () {
              input.focus();
            });
          }
        } else if (
          !root.classList.contains('is-menu-open') &&
          !root.classList.contains('is-mega-open')
        ) {
          forceSolidHeader(false);
        }
      }

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = toggle.getAttribute('aria-expanded') === 'true';
        setSearchOpen(!open);
      });

      document.addEventListener('click', function (event) {
        if (!searchRoot.contains(event.target)) setSearchOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setSearchOpen(false);
          toggle.focus();
        }
      });
    });

    if (fadeScroll) {
      updateScrollState();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    syncOverlay(root);
    window.addEventListener('load', function () {
      syncOverlay(root);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wpm-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-wpm-header]');
    if (root) {
      delete root.dataset.wpmHeaderReady;
      initHeader(root);
    }
  });
})();
